var map = {
	"./template.bet575": 1474,
	"./template.bet575.tsx": 1474,
	"./template.bet777": 1475,
	"./template.bet777.tsx": 1475,
	"./template.betblast": 1476,
	"./template.betblast.tsx": 1476,
	"./template.betgalaxy": 1477,
	"./template.betgalaxy.tsx": 1477,
	"./template.betprofessor": 1478,
	"./template.betprofessor.tsx": 1478,
	"./template.betroyale": 1479,
	"./template.betroyale.tsx": 1479,
	"./template.betstride": 1480,
	"./template.betstride.tsx": 1480,
	"./template.buffalobet": 1481,
	"./template.buffalobet.tsx": 1481,
	"./template.chromabet": 1482,
	"./template.chromabet.tsx": 1482,
	"./template.default": 663,
	"./template.default.tsx": 663,
	"./template.fiestabet": 1483,
	"./template.fiestabet.tsx": 1483,
	"./template.forsport": 1484,
	"./template.forsport.tsx": 1484,
	"./template.gigabet": 1485,
	"./template.gigabet.tsx": 1485,
	"./template.goldenbet888": 1486,
	"./template.goldenbet888.tsx": 1486,
	"./template.goldenrush": 1487,
	"./template.goldenrush.tsx": 1487,
	"./template.hyperbet": 1488,
	"./template.hyperbet.tsx": 1488,
	"./template.juicybet": 1489,
	"./template.juicybet.tsx": 1489,
	"./template.junglebet": 1490,
	"./template.junglebet.tsx": 1490,
	"./template.magnumbet": 1491,
	"./template.magnumbet.tsx": 1491,
	"./template.oldgill": 1492,
	"./template.oldgill.tsx": 1492,
	"./template.puntcity": 1493,
	"./template.puntcity.tsx": 1493,
	"./template.puntgenie": 1494,
	"./template.puntgenie.tsx": 1494,
	"./template.pyramidbet": 1495,
	"./template.pyramidbet.tsx": 1495,
	"./template.questbet": 1496,
	"./template.questbet.tsx": 1496,
	"./template.slambet": 1497,
	"./template.slambet.tsx": 1497,
	"./template.sterlingparker": 1498,
	"./template.sterlingparker.tsx": 1498,
	"./template.sugarcastle": 1499,
	"./template.sugarcastle.tsx": 1499,
	"./template.templebet": 1500,
	"./template.templebet.tsx": 1500,
	"./template.titanbet": 1501,
	"./template.titanbet.tsx": 1501,
	"./template.ts": 977,
	"./template.vikingbet": 1502,
	"./template.vikingbet.tsx": 1502,
	"./template.volcanobet": 1503,
	"./template.volcanobet.tsx": 1503,
	"./template.wellbet": 1504,
	"./template.wellbet.tsx": 1504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2433;